// Main Init
document.addEventListener('DOMContentLoaded', () => {
    console.log('Parakeet Theme Initialized');

    // Fund Row Accordion (Mobile)
    const fundWrappers = document.querySelectorAll('.fund-row-wrapper');

    fundWrappers.forEach(wrapper => {
        // Mobile accordion toggle.
        const header = wrapper.querySelector('.fund-mobile-header');
        if (header) {
            header.addEventListener('click', () => {
                const isActive = wrapper.classList.contains('is-active');
                fundWrappers.forEach(w => w.classList.remove('is-active'));
                if (!isActive) {
                    wrapper.classList.add('is-active');
                }
            });
        }

        // Desktop: make entire row clickable.
        const link = wrapper.querySelector('.btn-ver-fondo');
        if (link) {
            wrapper.style.cursor = 'pointer';
            wrapper.addEventListener('click', (e) => {
                if (e.target.closest('.btn-ver-fondo') || e.target.closest('.fund-mobile-header')) return;
                window.location.href = link.href;
            });
        }
    });

    // Mobile Filters Toggle
    const filtersBtn   = document.querySelector('.btn-filters-mobile');
    const filtersBlock = document.querySelector('.fondos-filters-block');

    const openFilters  = () => {
        filtersBlock.classList.add('is-open');
        filtersBtn?.classList.add('is-active');
        document.body.style.overflow = 'hidden';
    };
    const closeFilters = () => {
        filtersBlock.classList.remove('is-open');
        filtersBtn?.classList.remove('is-active');
        document.body.style.overflow = '';
    };

    if (filtersBtn && filtersBlock) {
        filtersBtn.addEventListener('click', openFilters);
    }

    // Back button
    filtersBlock?.querySelector('.filters-back-btn')?.addEventListener('click', closeFilters);

    // Restablecer: reset all pills to first (TODOS/PESOS) and re-apply
    filtersBlock?.querySelector('.btn-restablecer')?.addEventListener('click', () => {
        filtersBlock.querySelectorAll('.filter-group').forEach(group => {
            const pills = group.querySelectorAll('.pill');
            pills.forEach((p, i) => p.classList.toggle('active', i === 0));
        });
        // Trigger filter update
        filtersBlock.querySelectorAll('.filter-group .pill.active').forEach(p => p.click());
    });

    // Aplicar: close panel
    filtersBlock?.querySelector('.btn-aplicar')?.addEventListener('click', closeFilters);

    // Fondos Filters — client-side filtering
    initFondosFilters();

    // FCI Evolution Charts
    initFciCharts();
});

function initFondosFilters() {
    const filtersBlock = document.querySelector('.fondos-filters-block');
    if (!filtersBlock) return;

    // Active filter state: null means "show all" for that dimension.
    const activeFilters = {
        currency: null,
        risk: null,
        term: null,
    };

    // Maps the label text of each filter group to the data attribute key on fund rows.
    const groupToKey = {
        'Moneda': 'currency',
        'Riesgo': 'risk',
        'Plazo de liquidación': 'term',
    };

    // Maps pill display text to the data attribute value stored on the fund row.
    const pillToValue = {
        'PESOS':    'ars',
        'DÓLARES':  'usd',
        'TODOS':    null,
        'ALTO':     'alto',
        'MEDIO':    'medio',
        'BAJO':     'bajo',
        'INMEDIATO':'inmediato',
        '24 HS':    '24hs',
        '48 HS':    '48hs',
    };

    filtersBlock.querySelectorAll('.filter-group').forEach(group => {
        const labelEl = group.querySelector('label');
        if (!labelEl) return;

        const filterKey = groupToKey[labelEl.textContent.trim()];
        if (!filterKey) return;

        group.querySelectorAll('.pill').forEach(pill => {
            pill.addEventListener('click', () => {
                group.querySelectorAll('.pill').forEach(p => p.classList.remove('active'));
                pill.classList.add('active');

                activeFilters[filterKey] = pillToValue[pill.textContent.trim()] ?? null;
                applyFilters();
            });
        });
    });

    function applyFilters() {
        const rows = document.querySelectorAll('.fund-row-wrapper');

        rows.forEach(row => {
            const currencyMatch = !activeFilters.currency || row.dataset.currency === activeFilters.currency;
            const riskMatch     = !activeFilters.risk     || row.dataset.risk     === activeFilters.risk;
            const termMatch     = !activeFilters.term     || row.dataset.term     === activeFilters.term;
            row.classList.toggle('is-filtered-out', !(currencyMatch && riskMatch && termMatch));
        });

        // Hide entire risk sections when all their rows are filtered out.
        let anyVisibleGlobal = false;
        document.querySelectorAll('.fondos-list-block').forEach(section => {
            const sectionRows = section.querySelectorAll('.fund-row-wrapper');
            const anyVisible  = Array.from(sectionRows).some(r => !r.classList.contains('is-filtered-out'));
            section.classList.toggle('is-hidden', !anyVisible);
            if (anyVisible) anyVisibleGlobal = true;
        });

        const emptyState = document.getElementById('fondos-empty-state');
        if (emptyState) emptyState.style.display = anyVisibleGlobal ? 'none' : 'block';
    }
}
